import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Form, Field } from 'react-final-form';
import { Link } from "react-router-dom";
import { Row, Col, ButtonGroup, Button, Card, CardHeader, CardBody, CardTitle, CardText, CardFooter } from 'reactstrap';
import { FormGroup, Label } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { loadInvoice, loadGroups, loadUsers } from '../../../redux/modules';
import { Invoice, Payment, User } from '../../../models/';
import { Utils, isSuperAdmin, hasModule } from '../../../services/';
import {
    InvoiceDetails,
    ParentsField, ParentListItem,
    GroupsField, ClassroomListItem,
    InvoiceField, InvoiceListItem,
    PaymentModesField, PaymentTimesField,
    PaymentListItem,
} from '../../../components';
import Icon from '@mdi/react';
import {
    mdiLoading,
    mdiAccountArrowRightOutline,
    mdiAccountCircleOutline,
    mdiAccountChildOutline,
    mdiCardAccountPhoneOutline,
    mdiAccountGroupOutline,
    mdiAccountMultiplePlus,
    mdiCommentAccountOutline,
    mdiAccountCreditCardOutline,
} from '@mdi/js';

import { DatePicker } from 'react-widgets';

import './InvoiceForm.css';

const InvoiceForm = ({ onSubmit, isCreation }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const { users }              = useSelector(state => state.users);
    const { groups }             = useSelector(state => state.groups);
    const { invoice, isLoading, isLoadingOne } = useSelector(state => state.invoices);

    const renderDateTimePicker = ({ input: { onChange, value }, showTime }) =>
        <DatePicker
            onChange={onChange}
            format="DD MMM YYYY"
            includeTime={showTime}
            value={!value ? null : new Date(value)}
        />

    useEffect(() => {
        dispatch(loadUsers());
        dispatch(loadGroups());
    }, []);

    const reloadInvoice = () => {
        dispatch(loadInvoice(invoice.id));
    };

    return (
        <Form
            initialValues={ invoice }
            onSubmit={ values => { onSubmit(values); }}
            render={({ handleSubmit, pristine, form, submitting }) => (
                <form className="form" onSubmit={handleSubmit}>
                    <Field component="input" type="hidden" name="user_id" />
                    <Row className="main row-flex">
                        <Col sm={12} lg={6}>
                            <InvoiceDetails
                                paymentName="new_payment"
                                editable
                                invoice={invoice}
                                className="h-100"
                                pristine={pristine}
                                submitting={submitting}
                                isLoadingOne={isLoadingOne}
                                onPaymentDeleted={reloadInvoice}
                            />
                        </Col>
                        <Col sm={12} lg={6}>
                            <Card color="light" className="h-100">
                                <CardBody>
                                    <CardTitle tag="h3">
                                        <Icon path={mdiCommentAccountOutline} size={1.5} />&nbsp;
                                        {t('invoices.other_informations')}
                                    </CardTitle>
                                    <CardText tag="div">
                                        <FormGroup row>
                                            <Label for="remarks" sm={3}>{t('invoices.remarks')}</Label>
                                            <Col sm={9}>
                                                <Field component="textarea" rows={ 6 } className="form-control" name="remarks" id="remarks" />
                                            </Col>
                                        </FormGroup>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Row className="main">
                        <Col className="text-center">
                            <ButtonGroup>
                                <Button tag={Link} to={ -1 } color="warning">
                                    <span><i className="fa fa-arrow-left"></i>&nbsp;{t('common.back')}</span>
                                </Button>
                                <Button type="submit" color="success" disabled={pristine || submitting || isLoading}>
                                    <span>
                                        <i className={`fa ${ isLoading ? 'fa-spinner fa-spin' : 'fa fa-save'}`}></i>&nbsp;{t("common.save")}
                                    </span>
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                </form>
        )} />
    );
}

export default InvoiceForm;
